import {
  DIGIDIARY_FARM_SETUP,
  FARM_INFO_RESET,
  DIGIDIARY_EQUIPMENT_SETUP,
  DIGIDIARY_EQUIPMENT_DETAILS_RESET,
  DIGIDIARY_SET_LOADER,
  DIGIDIARY_SET_ALERT,
  DIGIDIARY_RESET_ALERT,
  DIGIDIARY_GET_EXPENSE_INFO,
  DIGIDIARY_SET_EXPENSE_TOTAL,
  DD_PUT_MY_FARM_DATA,
  DD_PUT_UPDATED_CROP_DETAILS,
  DD_PUT_ADD_NEW_CROP_DETAILS,
  SET_ALL_EQUIPMENT,
  SET_ACTIVITY_MODAL,
  DIGIDIARY_UPDATE_MY_FARM,
  DD_PUT_EXISTING_EQUIPMENT_DATA,
  TOTAL_INCOME_YIELD,
  DD_UPDATE_CROP_STATE,
  DIGIDIARY_INCOME_TIMESTAMP,
  DIGIDIARY_RESET_INCOME_TIMESTAMP,
  DIGIDIARY_SET_API_ERROR,
  DIGIDIARY_RESET_EQUIPMENT_TYPE,
} from '../actions';

const initialState = {
  farmInformation: {
    cropName: 'paddy',
    landArea: null,
    landUnit: 'ACRE',
    cropStartDate: null,
    cropCycle: null,
  },
  equipmentType: {
    equipmentType: 'Tractor',
    ownership: 'Owned',
  },
  isDigiDiaryLoading: false,
  alertMessage: {
    isVisible: false,
    type: null,
    variantType: null,
  },
  expenseInformation: {
    expenseTypesData: null,
    totalExpenseAmount: null,
    expenseType: null,
    totalIncome: null,
    netProfit: null,
    edit_phase: null,
    edit_subPhase: null,
  },
  crops: [],
  equipments: [],
  existingEquipments: [],
  allEquipments: [],
  myFarmLoading: false,
  incomeInformation: {
    yieldTotal: 0,
    otherTotal: 0,
    yieldTotalQtySold: 0,
    otherIncome: [],
    yieldIncome: [],
  },
  incomeTimeStamp: null,
  isActivityModalOpen: true,
  apiError: false,
};

const handleFarmInformation = (state, {data}) => {
  const newState = {...state.farmInformation};
  newState[data.field] = data.value;
  return {
    ...state,
    farmInformation: newState,
  };
};

const resetFarmInformation = (state) => {
  return {
    ...state,
    farmInformation: {
      cropName: 'paddy',
      landArea: null,
      landUnit: 'ACRE',
      cropStartDate: null,
      cropCycle: null,
    },
  };
};

const resetEquipmentDetails = (state) => {
  return {
    ...state,
    equipmentType: {
      equipmentType: state.equipmentType.equipmentType,
      ownership: state.equipmentType.ownership,
    },
  };
};

const handleEquipmentType = (state, {data}) => {
  const newState = {...state.equipmentType};
  newState[data.field] = data.value;
  return {
    ...state,
    equipmentType: newState,
  };
};

const digiDiarySetLoader = (state, {flag}) => {
  return {
    ...state,
    isDigiDiaryLoading: flag,
  };
};

const digiDiarySetAlert = (state, {message}) => {
  return {
    ...state,
    alertMessage: {
      isVisible: message.isVisible,
      type: message.type,
      variant: message.variant,
    },
  };
};
const digiDiaryResetAlert = (state) => {
  return {
    ...state,
    alertMessage: {
      isVisible: false,
      title: null,
      subTitle: null,
      variantType: null,
    },
  };
};
const digiDiaryExpenseInfo = (state, {data}) => {
  const newState = {...state.expenseInformation};
  newState[data.field] = data.value;
  return {
    ...state,
    expenseInformation: newState,
  };
};

const digiDiarySetExpenseTotal = (state, {data}) => {
  const newState = {...state.expenseInformation};
  newState[data.field] = data.value;
  return {
    ...state,
    expenseInformation: newState,
  };
};

const putDataForMyFarm = (state, {dataObj}) => {
  return {
    ...state,
    crops: dataObj.crops,
    equipments: dataObj.equipments,
    existingEquipments: dataObj.existingEquipments,
  };
};

const putDataForExistingEquipment = (state, {dataObj}) => {
  return {
    ...state,
    existingEquipments: dataObj.existingEquipments,
  };
};

const putUpdatedCropDetails = (state, {data}) => {
  const getUpdatedData = updateCropData(state.crops, data);
  return {
    ...state,
    crops: getUpdatedData,
  };
};

const updateCropData = (existingCrops, updatedCropsData) => {
  return existingCrops.map((crop) =>
    crop.cropId === updatedCropsData.cropId
      ? {
          ...crop,
          landArea: updatedCropsData.landArea,
          landUnit: updatedCropsData.landUnit,
          cropStartDate: updatedCropsData.cropStartDate,
          cropCycle: updatedCropsData.cropCycle,
        }
      : crop
  );
};

const updateNewAddedCrop = (state, {data}) => {
  return {
    ...state,
    crops: [...crops, data],
  };
};

const setAllEquipments = (state, {data}) => {
  return {
    ...state,
    allEquipments: data,
  };
};
const addIncomeTimeStamp = (state, {data}) => {
  return {
    ...state,
    incomeTimeStamp: data,
  };
};
const digiDiaryResetTimestamp = (state) => {
  return {
    ...state,
    incomeTimeStamp: null,
  };
};
const totalIncomeInformation = (state, {dataObj}) => {
  return {
    ...state,
    incomeInformation: dataObj,
  };
};

const updateCropState = (state, {dataObj}) => {
  return {
    ...state,
    crops: dataObj.crops,
  };
};

const setActivityModal = (state, {flag}) => {
  return {
    ...state,
    isActivityModalOpen: flag,
  };
};

const updateMyFarmData = (state, {dataObj}) => {
  return {
    ...state,
    crops: dataObj.crops,
  };
};

const setApiError = (state, {error}) => {
  return {
    ...state,
    apiError: error,
  };
};

const resetEquipmentType = (state, data) => {
  return {
    ...state,
    equipmentType: {
      equipmentType: 'Tractor',
      ownership: 'Owned',
    },
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DIGIDIARY_FARM_SETUP:
      return handleFarmInformation(state, action);
    case FARM_INFO_RESET:
      return resetFarmInformation(state);
    case DIGIDIARY_EQUIPMENT_SETUP:
      return handleEquipmentType(state, action);
    case DIGIDIARY_EQUIPMENT_DETAILS_RESET:
      return resetEquipmentDetails(state);
    case DIGIDIARY_SET_LOADER:
      return digiDiarySetLoader(state, action);
    case DIGIDIARY_SET_ALERT:
      return digiDiarySetAlert(state, action);
    case DIGIDIARY_RESET_ALERT:
      return digiDiaryResetAlert(state);
    case DIGIDIARY_GET_EXPENSE_INFO:
      return digiDiaryExpenseInfo(state, action);
    case DIGIDIARY_SET_EXPENSE_TOTAL:
      return digiDiarySetExpenseTotal(state, action);
    case DD_PUT_MY_FARM_DATA:
      return putDataForMyFarm(state, action);
    case DD_PUT_EXISTING_EQUIPMENT_DATA:
      return putDataForExistingEquipment(state, action);
    case DD_PUT_UPDATED_CROP_DETAILS:
      return putUpdatedCropDetails(state, action);
    case DD_PUT_ADD_NEW_CROP_DETAILS:
      return updateNewAddedCrop(state, action);
    case SET_ALL_EQUIPMENT:
      return setAllEquipments(state, action);
    case TOTAL_INCOME_YIELD:
      return totalIncomeInformation(state, action);
    case DD_UPDATE_CROP_STATE:
      return updateCropState(state, action);
    case DIGIDIARY_INCOME_TIMESTAMP:
      return addIncomeTimeStamp(state, action);
    case DIGIDIARY_RESET_INCOME_TIMESTAMP:
      return digiDiaryResetTimestamp(state);
    case SET_ACTIVITY_MODAL:
      return setActivityModal(state, action);
    case DIGIDIARY_UPDATE_MY_FARM:
      return updateMyFarmData(state, action);
    case DIGIDIARY_SET_API_ERROR:
      return setApiError(state, action);
    case DIGIDIARY_RESET_EQUIPMENT_TYPE:
      return resetEquipmentType(state, action);
    default:
      return state;
  }
};

export default reducer;
